import React, {useEffect} from 'react';
import styled from 'styled-components';
import {ReactComponent as Chevron} from '../../assets/arrow.svg';
import RadioButton from '../RadioButton';
import {ReactComponent as Checkmark} from '../../assets/checkmark_icon.svg';
import AgeSetComplete from './AgeSetComplete';
import * as UserAction from '../../store/actions/user';
import {selectAgeRating} from '../../store/reducers';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {analyticsTrackState} from '../../helpers/Analytics';

export default function AgeRatingView({goBack, show}) {
    //const [selected, setSelected] = React.useState(12);
    const rating = useSelector(selectAgeRating);
    const [showEndScreen, setShowEndScreen] = React.useState(false);
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [currentRating, setCurrentRating] = React.useState(rating);

    const select12 = () => {
        setCurrentRating(12);
    };

    const select10 = () => {
        setCurrentRating(10);
    };

    const selectAll = () => {
        setCurrentRating(1);
    };

    useEffect(() => {
        if (!show) {
            //hide after animation
            setTimeout(() => {
                setShowEndScreen(false);
            }, 200);
        } else {
            analyticsTrackState('setagerating');
        }
    }, [show]);

    const commit = () => {
        setShowEndScreen(true);
        dispatch(UserAction.setAgeRating(currentRating));
    };

    return (
        <Container show={show}>
            {!showEndScreen && (
                <Header onClick={goBack}>
                    <ChevronIcon />
                    <span>{t('ageRating.title')}</span>
                </Header>
            )}
            {!showEndScreen && (
                <Content>
                    <Title>{t('ageRating.subtitle')}</Title>
                    <RadioButton
                        label={t('ageRating.age12')}
                        onPress={select12}
                        selected={currentRating === 12}
                    />
                    <RadioButton
                        label={t('ageRating.age10')}
                        onPress={select10}
                        selected={currentRating === 10}
                    />
                    <RadioButton
                        label={t('ageRating.all')}
                        onPress={selectAll}
                        selected={currentRating === 1}
                    />
                    <Disclaimer>{t('ageRating.disclaimer')}</Disclaimer>
                    <ConfirmButton onClick={commit}>
                        {t('ageRating.cta')}
                        <Checkmark />
                    </ConfirmButton>
                </Content>
            )}
            {showEndScreen && <AgeSetComplete onClose={goBack} />}
        </Container>
    );
}

const Container = styled.div`
    width: 311px;
    background-color: #363036;
    position: absolute;
    left: ${({show}) => (show ? '0' : '311px')};
    opacity: ${({show}) => (show ? '1' : '0')};
    transition: all 0.2s ease-in-out;
    border-radius: 4px;
    overflow: hidden;
`;

const Content = styled.div`
    margin: 18px 15px;
`;

const Header = styled.div`
    height: 62px;
    display: flex;
    flex-direction: row;
    background-color: black;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    span {
        width: 100%;
        margin-right: 40px;
    }
`;

const ChevronIcon = styled(Chevron)`
    margin-left: 10px;
    width: 28px;
    height: 28px;

    transform: scaleX(-1);
    path {
        fill: #fff;
    }
    cursor: pointer;
`;

const Title = styled.div`
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    margin: 20px 20px;
    line-height: 20px;
`;

const Disclaimer = styled.div`
    font-size: 14px;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 25px;
`;

const ConfirmButton = styled.div`
    display: flex;
    height: 45px;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(90deg, #f55a86 0%, #ec098c 100%);
    border-radius: 6px;
    text-transform: uppercase;
    font-family: TTNormsProExtraBlack;
    font-size: 20px;
    padding: 0px 20px;
    path {
        fill: #fff;
    }
    cursor: pointer;
`;
